import * as React from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { connect, useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import axios from "axios";
import { ACTUALIZAR_LISTA } from "../../../../redux/constanst";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import EditIcon from "@mui/icons-material/Edit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import SaveIcon from "@mui/icons-material/Save";
import DisabledByDefaultIcon from "@mui/icons-material/DisabledByDefault";
import { MenuItem, Select } from "@mui/material";
import { forMiles, hosting } from "./../../models/buscar";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function CheckTarifaServicioList({ data, id_empresa }) {
  const dispatch = useDispatch();
  const { actualizarLista } = useSelector((state) => state.userState);
  const [editNow, setEditNow] = React.useState(false);
  const [datosAll, SetDatosAll] = React.useState({});
  const [add, setAdd] = React.useState(false);
  const [preselect, setPreselect] = React.useState('');
const [tarifas, setTarifas] = React.useState([]);
  const handlerEdit = (id) => {
    setAdd(false);
    setEditNow(id);
  };

  const selectTarifasAdmin = () => {
    axios
      .get(`${hosting}/mimegacall/api/select_tarifas_servicio_admin.php`)
      .then((response) => {
        setTarifas(Object.values(response.data))
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  React.useEffect(() =>{
    selectTarifasAdmin()
  },[])

  const eliminarDatos = (datos) => {
    Swal.fire({
      title: `¿Seguro que quiere eliminar a ${datos.name}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .get(
            `${hosting}/mimegacall/api/delete_tarifa_servicios.php?id=${datos.id}`
          )
          .then((response) => {
            Swal.fire(response.data.mensaje, ``, `${response.data.type}`).then(
              (result) => {
                if (!response.data.error) {
                  dispatch({
                    type: ACTUALIZAR_LISTA,
                    actualizarLista: !actualizarLista,
                  });
                }
              }
            );
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    });
  };

  const envioDatos = () => {
    if(!datosAll.cost || !datosAll.id_servicio || !datosAll.cantidad || !datosAll.tipo){
      return
    }
    axios
      .get(
        `${hosting}/mimegacall/api/addEdit_tarifa_servicio.php?id=${
          datosAll.id
        }&id_user=${id_empresa}&name=${datosAll.id_servicio}&cantidad=${
          datosAll.cantidad
        }&cost=${datosAll.cost.replace(",", ".")}&tipo=${datosAll.tipo}`
      )
      .then((response) => {
        if (response.data.type === "error") {
          Swal.fire(response.data.mensaje, ``, `${response.data.type}`);
          return;
        } else {
        }
        Swal.fire(response.data.mensaje, ``, `${response.data.type}`).then(
          (result) => {
            dispatch({
              type: ACTUALIZAR_LISTA,
              actualizarLista: !actualizarLista,
            });
            setEditNow(false);
            SetDatosAll({});
            setAdd(false);
          }
        );
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const handleUpdateNumber = (e) => {
    if (
      (e.keyCode >= 48 && e.keyCode <= 57) ||
      (e.keyCode >= 96 && e.keyCode <= 105) ||
      e.keyCode === 188
    ) {
      SetDatosAll({
        ...datosAll,
        [e.target.id]: e.target.value,
      });
      return;
    } else if (e.keyCode !== 8) {
      e.preventDefault();
      return;
    }
    SetDatosAll({
      ...datosAll,
      [e.target.id]: e.target.value,
    });
  };

  
  return (
    <>
      <div
        style={{
          display: "grid",
          justifyContent: "end",
        }}
      >
        <Button
          style={{
            width: "auto",
            height: 30,
            backgroundColor: "red",
            marginRight: 30,
            marginBottom: 10,
            marginTop: 0,
          }}
          onClick={() => {
            setAdd(true);
            SetDatosAll({});
            setEditNow("");
          }}
          variant="contained"
        >
          <p style={{ fontSize: 10 }}>{"AGREGAR TARIFA"}</p>
        </Button>
      </div>
      <div
        style={{
          padding: "4% 4%",
        }}
      >
        <TableContainer component={Paper}>
          <Table
            sx={{ maxWidth: "100%", flex: 1, width: "100%" }}
            aria-label="customized table"
          >
            <TableHead style={{ background: "red" }}>
              {data.length > 0 ? (
                <TableRow>
                  <StyledTableCell
                    style={{ backgroundColor: "#F4796D", width: 180 }}
                  >
                    Nombre
                  </StyledTableCell>
                  <StyledTableCell
                    style={{ backgroundColor: "#F4796D", width: 100 }}
                    align="center"
                  >
                    Cantidad
                  </StyledTableCell>
                  <StyledTableCell
                    style={{ backgroundColor: "#F4796D", width: 100 }}
                    align="center"
                  >
                    Valor individual
                  </StyledTableCell>
                  <StyledTableCell
                    style={{ backgroundColor: "#F4796D", width: 100 }}
                    align="center"
                  >
                    CLP
                  </StyledTableCell>
                  <StyledTableCell
                    style={{ backgroundColor: "#F4796D", width: 100 }}
                    align="center"
                  >
                    UF
                  </StyledTableCell>
                  <StyledTableCell
                    style={{ backgroundColor: "#F4796D", width: 100 }}
                    align="left"
                  ></StyledTableCell>
                </TableRow>
              ) : (
                <>
                  <TableRow>
                    <StyledTableCell
                      style={{ backgroundColor: "#F4796D", width: 180 }}
                    >
                      Nombre
                    </StyledTableCell>
                    <StyledTableCell
                      style={{ backgroundColor: "#F4796D", width: 100 }}
                      align="center"
                    >
                      Cantidad
                    </StyledTableCell>
                    <StyledTableCell
                      style={{ backgroundColor: "#F4796D", width: 100 }}
                      align="center"
                    >
                      Valor individual
                    </StyledTableCell>
                    <StyledTableCell
                      style={{ backgroundColor: "#F4796D", width: 100 }}
                      align="center"
                    >
                      CLP
                    </StyledTableCell>
                    <StyledTableCell
                      style={{ backgroundColor: "#F4796D", width: 100 }}
                      align="center"
                    >
                      UF
                    </StyledTableCell>
                    <StyledTableCell
                      style={{ backgroundColor: "#F4796D", width: 100 }}
                      align="left"
                    ></StyledTableCell>
                  </TableRow>
                  
                </>
              )}
            </TableHead>
            <TableBody>
              {data.map((dato, index) => {
                return (
                  <StyledTableRow>
                    <StyledTableCell
                      component="th"
                      scope="row"
                      style={{ width: 180 }}
                    >
                      {dato.name}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {editNow === index ? (
                        <TextField
                          id="cantidad"
                          defaultValue={dato.cantidad}
                          size="small"
                          style={{ width: 100 }}
                          onChange={(e) => {
                            SetDatosAll({
                              ...datosAll,
                              [e.target.id]: e.target.value,
                            });
                          }}
                          onKeyDown={(e) => {
                            handleUpdateNumber(e);
                          }}
                        />
                      ) : (
                        forMiles(dato.cantidad)
                      )}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {editNow === index ? (
                        <TextField
                          id="cost"
                          defaultValue={dato.cost.replace(".", ",")}
                          size="small"
                          style={{ width: 100 }}
                          onChange={(e) => {
                            SetDatosAll({
                              ...datosAll,
                              [e.target.id]: e.target.value,
                            });
                          }}
                          onKeyDown={(e) => {
                            handleUpdateNumber(e);
                          }}
                        />
                      ) : dato.tipo === "1" ? (
                        dato.cost.replace(".", ",")
                      ) : (
                        forMiles(dato.cost)
                      )}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {editNow === index ? (
                        <Checkbox
                          id="tipo"
                          defaultChecked
                          checked={datosAll.tipo === "0" ? true : false}
                          value={0}
                          onChange={(e) => {
                            SetDatosAll({
                              ...datosAll,
                              [e.target.id]: e.target.value,
                            });
                          }}
                          inputProps={{ "aria-label": "controlled" }}
                        />
                      ) : dato.tipo === "0" ? (
                        <CheckCircleIcon color="success" />
                      ) : (
                        <CancelIcon color="error" />
                      )}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {editNow === index ? (
                        <Checkbox
                          id="tipo"
                          defaultChecked
                          value={1}
                          checked={datosAll.tipo === "1" ? true : false}
                          onChange={(e) => {
                            SetDatosAll({
                              ...datosAll,
                              [e.target.id]: e.target.value,
                            });
                          }}
                          inputProps={{ "aria-label": "controlled" }}
                        />
                      ) : dato.tipo === "1" ? (
                        <CheckCircleIcon color="success" />
                      ) : (
                        <CancelIcon color="error" />
                      )}
                    </StyledTableCell>

                    <StyledTableCell
                      align="right"
                      style={{
                        display: "flex",
                        textAlign: "right",
                      }}
                    >
                      {editNow === index ? (
                        <>
                          <Button
                            style={{
                              width: "auto",
                              height: 30,
                              backgroundColor: "red",
                              marginLeft: 20,
                              marginRight: 20,
                              marginBottom: 10,
                              marginTop: 10,
                            }}
                            onClick={() => {
                              SetDatosAll({});
                              handlerEdit();
                            }}
                            variant="contained"
                          >
                            <p style={{ fontSize: 10 }}>
                              <DisabledByDefaultIcon />
                            </p>
                          </Button>
                          <Button
                            style={{
                              width: "auto",
                              cursor: "pointer",
                              height: 30,
                              backgroundColor: "red",
                              marginLeft: 20,
                              marginRight: 20,
                              marginBottom: 10,
                              marginTop: 10,
                            }}
                            onClick={() => {
                              envioDatos();
                            }}
                            variant="contained"
                          >
                            <p style={{ fontSize: 10 }}>
                              <SaveIcon />
                            </p>
                          </Button>
                        </>
                      ) : (
                        <>
                          <Button
                            style={{
                              width: "auto",
                              height: 30,
                              backgroundColor: "grey",
                              marginLeft: 20,
                              marginRight: 20,
                              marginBottom: 10,
                              marginTop: 10,
                              cursor: "pointer",
                            }}
                            variant="contained"
                            onClick={() => {
                              SetDatosAll(dato);
                              handlerEdit(index, dato.tipo);
                            }}
                          >
                            <p style={{ fontSize: 10 }}>
                              <EditIcon />{" "}
                            </p>
                          </Button>
                          <Button
                            style={{
                              width: "auto",
                              height: 30,
                              backgroundColor: "grey",
                              marginLeft: 20,
                              marginRight: 20,
                              marginBottom: 10,
                              marginTop: 10,
                              cursor: "pointer",
                            }}
                            variant="contained"
                            onClick={() => {
                              eliminarDatos(dato);
                            }}
                          >
                            <p style={{ fontSize: 10 }}>
                              <DeleteForeverIcon />
                            </p>
                          </Button>
                        </>
                      )}
                    </StyledTableCell>
                  </StyledTableRow>
                );
              })}
              {add ? (
                <StyledTableRow>
                  <StyledTableCell component="th" scope="row">
                    <Select
                      value={preselect}
                      style={{
                        width: "100%",
                        color: 'black',
                      }}
                      renderValue={(value) => `${value.name}`}
                      id="name"
                      onChange={(e) => {
                        SetDatosAll({
                          ...datosAll,
                          id_servicio: e.target.value.id,
                          name: e.target.value.name,
                          tipo: e.target.value.tipo
                        });
                        setPreselect(e.target.value)
                      }}
                      onKeyDown={(e) => {
                        handleUpdateNumber(e);
                      }}
                    >
                      {tarifas.map(dato => 
                        <MenuItem
                         id="name" value={dato}>
                        {dato.name}
                      </MenuItem>
                      )}
                    </Select>
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    <TextField
                      id="cantidad"
                      size="small"
                      style={{ width: 100 }}
                      onChange={(e) => {
                        SetDatosAll({
                          ...datosAll,
                          [e.target.id]: e.target.value,
                        });
                      }}
                      onKeyDown={(e) => {
                        handleUpdateNumber(e);
                      }}
                    />
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    <TextField
                      onChange={(e) => {
                        SetDatosAll({
                          ...datosAll,
                          [e.target.id]: e.target.value,
                        });
                      }}
                      id="cost"
                      size="small"
                      style={{ width: 100 }}
                      onKeyDown={(e) => {
                        handleUpdateNumber(e);
                      }}
                    />
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    <Checkbox
                      defaultChecked
                      id="tipo"
                      value={0}
                      checked={preselect.tipo === '0' ? true : false}
                      onChange={(e) => {
                        
                        setPreselect({...preselect, tipo: e.target.value})
                        SetDatosAll({
                          ...datosAll,
                          [e.target.id]: e.target.value,
                        });
                      }}
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    <Checkbox
                      defaultChecked
                      id="tipo"
                      value={1}
                      checked={preselect.tipo === '1' ? true : false}
                      onChange={(e) => {
                        setPreselect({...preselect, tipo: e.target.value})
                        SetDatosAll({
                          ...datosAll,
                          [e.target.id]: e.target.value,
                        });
                      }}
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  </StyledTableCell>

                  <StyledTableCell
                    align="right"
                    style={{
                      display: "flex",
                      textAlign: "right",
                    }}
                  >
                    <Button
                      style={{
                        width: "auto",
                        height: 30,
                        backgroundColor: "red",
                        marginLeft: 20,
                        marginRight: 20,
                        marginBottom: 10,
                        marginTop: 10,
                      }}
                      onClick={() => {
                        envioDatos();
                      }}
                      variant="contained"
                    >
                      <p style={{ fontSize: 10 }}><SaveIcon /></p>
                    </Button>
                    <Button
                      style={{
                        width: "auto",
                        height: 30,
                        backgroundColor: "red",
                        marginLeft: 20,
                        marginRight: 20,
                        marginBottom: 10,
                        marginTop: 10,
                      }}
                      onClick={() => {
                        setAdd(false);
                        SetDatosAll({});
                        setEditNow("");
                      }}
                      variant="contained"
                    >
                      <p style={{ fontSize: 10 }}><DisabledByDefaultIcon /></p>
                    </Button>
                  </StyledTableCell>
                </StyledTableRow>
              ) : null}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </>
  );
}
const mapStateToProps = (store) => ({});

export default connect(mapStateToProps, null)(CheckTarifaServicioList);
